import { format } from 'sql-formatter';
import { identify } from 'sql-query-identifier';

export const toJSON = (str) => {
  try {
    const result = JSON.stringify(str);
    return result;
  } catch (error) {
    console.log(error);
    return 'CANNOT STRINGIFY';
  }
};

export const parseToInt = (str) => {
  try {
    const result = parseInt(str, 10);
    if (isNaN(result)) {
      return null;
    }
    return result;
  } catch (error) {
    console.log(error);
    return null;
  }
};
export const parseJSON = (str) => {
  try {
    const result = JSON.parse(str);
    return result;
  } catch (error) {
    console.log(error);
    return 'CANNOT PARSE JSON';
  }
};

export const reverseUrl = (url) => {
  try {
    if (!url) {
      return '/';
    }
    const urlArray = url.split('SDFWE_ORMTLDR');
    return urlArray.join('/');
  } catch (error) {
    return '/';
  }
};

export const setAuthToken = (token) => {
  localStorage.setItem('from_client_local_token', token);
};

export const parseUrl = (url) => {
  try {
    if (!url) {
      return '/';
    }
    const urlArray = url.split('/');
    return urlArray.join('SDFWE_ORMTLDR');
  } catch (error) {
    return '/';
  }
};

export const validateRegisterForm = (form) => {
  let errors = [];
  const { firstName, lastName, email, password, password2 } = form;
  if (!firstName || !lastName || !email || !password || !password2) {
    errors = [...errors, { id: 'firstName', msg: 'Please provide a valid name' }];
  }
  if (password !== password2) {
    errors = [...errors, { id: 'password', msg: 'Please chack your password' }];
  }
  return errors.length ? { errors } : { success: true };
};

export const parseDate = (date) => {
  try {
    const newDate = new Date(date);
    if (newDate) {
      return newDate.toDateString();
    }
    return false;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export const getRandomInt = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const passwordGenerator = (passwordLength) => {
  if (typeof passwordLength !== 'number' || passwordLength < 1) {
    return '';
  }

  try {
    const capLet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
    const lowLet = capLet
      .map((letter) => (typeof letter === 'string' ? letter.toLowerCase() : null))
      .filter((letter) => typeof letter === 'string')
      .filter((letter) => letter);
    const signs = ['!', '@', '#', '$', '%', '^', '&', '*', '!'];
    const digits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

    const arrayOfArrays = [capLet, lowLet, signs, digits];

    let password = '';

    for (let i = 0; i < passwordLength; i++) {
      const array = arrayOfArrays[getRandomInt(0, arrayOfArrays.length - 1)];
      const letter = array[getRandomInt(0, array.length - 1)];
      password += letter;
    }
    return password;
  } catch (error) {
    console.log(error);
    return '';
  }
};

export const flattedArrayByKey = (array, key) => {
  try {
    if (!Array.isArray(array) || !key) {
      return [];
    }
    const newObject = {};
    array.map((item) => {
      if (newObject[item[key]]) {
        return (newObject[item[key]] = [...newObject[item[key]], item]);
      }
      return (newObject[item[key]] = [item]);
    });
    const newArray = Object.entries(newObject).map((entry) => {
      return { [key]: entry[0], items: entry[1] };
    });
    return newArray;
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const parseRangeQuery = (condition) => {
  try {
    if (!condition || !condition.rangeQuery || typeof condition.rangeQuery.table_name !== 'string') {
      return 'SELECT ...';
    }
    if (!Array.isArray(condition.rangeQuery.columnsIds) || condition.rangeQuery.columnsIds.length < 1) {
      return 'SELECT ...';
    }
    if (!Array.isArray(condition.rangeQuery.conditions) || condition.rangeQuery.conditions.length < 1) {
      return format(
        `SELECT ${condition.rangeQuery.columnsIds
          .map((coId) => {
            const column = condition.columns.filter((col) => col._id === coId)[0];
            if (column) {
              return column.column_name;
            }
            return null;
          })
          .filter((flt) => flt)
          .join(', ')} FROM ${condition.rangeQuery.table_name} ${
          condition.rangeQuery.isLimit ? `LIMIT ${condition.rangeQuery.limit || '100000'}` : ''
        }`,
        {
          language: 'sql',
          tabWidth: 10,
          keywordCase: 'upper',
          linesBetweenQueries: 2,
          expressionWidth: 200,
        },
      );
    }

    return format(
      `SELECT ${condition.rangeQuery.columnsIds
        .map((coId) => {
          const column = condition.columns.filter((col) => col._id === coId)[0];
          if (column) {
            return column.column_name;
          }
          return null;
        })
        .filter((flt) => flt)
        .join(', ')} FROM ${condition.rangeQuery.table_name} WHERE ${condition.rangeQuery.conditions.map((con, i) => {
        const column = condition.columns.filter((flt) => flt._id === con.field)[0];
        const dataTypeIsString =
          column.data_type?.includes('timestamp') ||
          column.data_type?.includes('text') ||
          column.data_type?.includes('json') ||
          column.data_type?.includes('character');

        return `${i === 0 ? '' : con.conType} ${column?.column_name} ${con.operation} ${
          dataTypeIsString ? `'${con.value}'` : con.value
        } `;
      })}${condition.rangeQuery.isLimit ? ` LIMIT ${condition.rangeQuery.limit || '100000'}` : ''}`,
      {
        language: 'sql',
        tabWidth: 10,
        keywordCase: 'upper',
        linesBetweenQueries: 2,
        expressionWidth: 200,
      },
    );
  } catch (error) {
    console.log(error);
    return 'SELECT ...';
  }
};

export const checkIfOnlySelect = (query) => {
  try {
    const result = identify(query);
    if (Array.isArray(result) && result[0]) {
      const checkIfAllAreTypeSelect = result.map((con) => (con.type === 'SELECT' ? 0 : 1)).reduce((a, b) => a + b, 0);
      return checkIfAllAreTypeSelect === 0;
    }
    return false;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export const getVariables = (condition, subCondition) => {
  try {
    const fromRangeQuery = condition.columns
      .map((col) => {
        if (condition.rangeQuery?.columnsIds?.includes(col._id)) {
          return { ...col, varType: 'FROM_RANGE_QUERY', id: col._id, name: col.column_name };
        }
        return null;
      })
      .filter((flt) => flt);

    const fromVariables = subCondition.variables.map((variable) => {
      return { ...variable, varType: 'FROM_VARIABLES', id: variable._id, name: variable.name };
    });

    const options = [...fromRangeQuery, ...fromVariables];
    return options;
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const parseSentence = (sentence, condition, subCondition) => {
  const variables = getVariables(condition, subCondition);
  try {
    if (sentence.includes('{{')) {
      let variableFromText = sentence.match(/\{{(.*?)\}}/);
      let variable = variables.filter((flt) => flt.id === variableFromText[1])[0];
      sentence = sentence.replace(variableFromText[0], `[${variable.name}]`);
      return parseSentence(sentence, condition, subCondition);
    } else {
      return sentence;
    }
  } catch (error) {
    return sentence;
  }
};

export const compareArrayOfInt = (array1, array2) => {
  try {
    console.log({
      arr1: array1.sort(),
      arr2: array2.sort(),
    });
    return JSON.stringify(array1.sort()) === JSON.stringify(array2.sort());
  } catch (error) {
    console.log({ array1, array2 });
    console.log(error);
    return false;
  }
};

export const compareArrayOfString = (array1, array2) => {
  try {
    return JSON.stringify(array1) === JSON.stringify(array2);
  } catch (error) {
    console.log(error);
    return false;
  }
};
export const validURL = (str) => {
  var pattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$',
    'i',
  ); // fragment locator
  return !!pattern.test(str);
};

export const stringIsAValidHttpsUrl = (s) => {
  try {
    if (!validURL(s)) {
      return false;
    }
    const url = new URL(s);
    return url.protocol === 'https:';
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const checkChangeBudgetActionData = (actionData) => {
  try {
    if (!actionData) {
      return { msg: 'Action Data is Missing - ERROR CODE: 98724', error: true };
    }
    const { name, useFixedBudget, fixedValue, unit, value } = actionData;
    if (!name) {
      return { msg: 'Action Name is Missing - ERROR CODE: 738173', error: true };
    }
    if (useFixedBudget && !fixedValue) {
      return { msg: 'Fixed Value is Missing - ERROR CODE: 124726', error: true };
    }
    if (!useFixedBudget && !value) {
      return { msg: 'Value is Missing - ERROR CODE: 124726', error: true };
    }
    if (!useFixedBudget && !unit) {
      return { msg: 'Unit is Missing - ERROR CODE: 124726', error: true };
    }

    return { success: true };
  } catch (error) {
    console.log(error);
    return { msg: 'Something is wrong with the Action Data', error: true };
  }
};

export const injectVariablesToQuery = (query, variables) => {
  try {
    if (typeof query !== 'string' || !Array.isArray(variables)) {
      return query;
    }
    let newQuery = query;
    // variable names will be wrapped with {{variable.name}}, variable ID will be wrapped with [[variable._id]]
    // replace all occurrences of [[variable._id]] with the variable value
    variables.forEach((variable) => {
      const variableIdWrapped = `[[${variable._id}]]`;
      const variableNameWrapped = `{{${variable.name}}}`;
      newQuery = newQuery.split(variableIdWrapped).join(variable.value);
      newQuery = newQuery.split(variableNameWrapped).join(variable.value);
    });

    return newQuery;
  } catch (error) {
    console.log(error);
    return query;
  }
};
